import '../css/App.css';
import 'core-js/es6/promise';
import 'core-js/fn/object/assign';
import React, { Component } from 'react';
import CalcControl from "./CalcControl";
import PropertyCalcControl from "./PropertyCalcControl";
import 'whatwg-fetch';

const currency = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'code',
    minimumFractionDigits: 2
});

const percentage = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 3
});

const TAB_VARIABLE = 'Variabler Zinssatz';
const TAB_FIXED = 'Fixer Zinssatz';

const TAB_COMMON = 'Allgemein';
const TAB_PROPERTY = 'Immobilien';

class App extends Component {
    constructor(props) {
        super(props);

        this.onSliderChange = this.onSliderChange.bind(this);
        this.onSliderEnd = this.onSliderEnd.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.calculate = this.calculate.bind(this);
        this.updateResults = this.updateResults.bind(this);

        this.onSliderChangeProperty = this.onSliderChangeProperty.bind(this);
        this.onSliderEndProperty = this.onSliderEndProperty.bind(this);
        this.onInputChangeProperty = this.onInputChangeProperty.bind(this);
        this.onModeChangeProperty = this.onModeChangeProperty.bind(this);
        this.calculateProperty = this.calculateProperty.bind(this);
        this.updateResultsProperty = this.updateResultsProperty.bind(this);

        this.formatCurrencyNumber = this.formatCurrencyNumber.bind(this);
        this.formatPercentNumber = this.formatPercentNumber.bind(this);

        this.defaultFixedObjectCosts = 150000.0;
        this.defaultFixedEquity = 50000.0;
        this.defaultFixedDuration = 25.0;
        this.defaultFixedRate = 3.70;

        this.defaultVariableObjectCosts = 150000.0;
        this.defaultVariableEquity = 50000.0;
        this.defaultVariableDuration = 25.0;
        this.defaultVariableRate = 4.875;

        this.state = {
            objectCosts: this.defaultFixedObjectCosts,
            equity: this.defaultFixedEquity,
            duration: this.defaultFixedDuration,
            rate: this.defaultFixedRate,

            buyingCostsProperty: 2200000,
            closingCostsFactorProperty: 6.5,
            closingCostsProperty: 4225.0,
            objectCostsProperty: 2343000,
            equityProperty: 300000,
            durationProperty: 35,
            rateProperty: 3.75,

            output: {
                creditAmount: 56000.0,
                monthlyInstallment: 947.6564983908447,
                effectiveRate: 0.4178886416850562,
                totalRefund: 56859.38990345068,
                avail: 54413.0,
                monthlyBonus: 2.78,
                duration: 5.0,
                rate: 0.375,
                handlingFee: 1.5,
                deedRegistration: 1.2,
                monthlyActivityCharge: 5.4,

                creditAmountProperty: 55225.0,
                monthlyInstallmentProperty: 934.6163414934713,
                effectiveRateProperty: 0.4183316569479038,
                totalRefundProperty: 56076.98048960828,
                availProperty: 53658.925,
                monthlyBonusProperty: 2.74,
                handlingFeeProperty: 1.5,
                deedRegistrationProperty: 1.2,
                monthlyActivityChargeProperty: 5.4
            },
            referrerProperty: '',
            objectTypeProperty: '',
            targetProperty: 'anfrage',
            modeProperty: '',
            activeTab: TAB_FIXED,
            outerActiveTab: TAB_COMMON
        };

    }

    componentDidMount() {
        const state = { ...this.state };

        const closingCosts = state.buyingCostsProperty * (this.state.closingCostsFactorProperty / 100);
        state.closingCostsProperty = closingCosts;
        state.objectCostsProperty = state.buyingCostsProperty + closingCosts;

        this.setState(state);

        this.calculate(this.state);
        this.calculateProperty(this.state);
    }

    onSliderChange(key, value) {
        const state = { ...this.state };
        state[key] = value;

        if (key === 'objectCosts')
            state['equity'] = parseFloat((state[key] * 0.2).toFixed(2));
        else if (key === 'equity' && state['objectCosts'] < state[key] / 0.8)
            state['objectCosts'] = parseFloat((state[key] / 0.8).toFixed(2));
        if (key === 'duration' && this.state.activeTab === TAB_FIXED) {
            switch (Number(value)) {
                case 10:
                    this.setState({ rate: 3.30 });
                    state['rate'] = 3.30;
                    break;
                case 15:
                    this.setState({ rate: 3.50 });
                    state['rate'] = 3.50;
                    break;
                case 20:
                    this.setState({ rate: this.defaultFixedRate });
                    state['rate'] = this.defaultFixedRate;
                    break;
                case 25:
                    this.setState({ rate: 3.70 });
                    state['rate'] = 3.70;
                    break;
                case 30:
                    this.setState({ rate: 3.75 });
                    state['rate'] = 3.75;
                    break;
                case 35:
                    this.setState({ rate: 3.75 });
                    state['rate'] = 3.75;
                    break;
            }

        }

        this.setState(state);
    }

    onSliderEnd() {
        this.calculate(this.state);
    }

    onInputChange(value, key) {

        const state = { ...this.state };
        state[key] = parseFloat(value);

        /*
        if(key === 'objectCosts')
            state['equity'] = parseFloat((state[key] * 0.2).toFixed(2));
        else if(key === 'equity' && state['objectCosts'] < state[key] / 0.8)
            state['objectCosts'] = parseFloat((state[key] / 0.8).toFixed(2));
        */

        if (key === 'equity' && state['objectCosts'] < state[key] / 0.8)
            state['objectCosts'] = parseFloat((state[key] / 0.8).toFixed(2));

        this.setState(state);

        if (key === 'duration' && this.state.activeTab === TAB_FIXED) {
            switch (Number(value)) {
                case 10:
                    this.setState({ rate: 3.30 });
                    state['rate'] = 3.30;
                    break;
                case 15:
                    this.setState({ rate: 3.50 });
                    state['rate'] = 3.50;
                    break;
                case 20:
                    this.setState({ rate: this.defaultFixedRate });
                    state['rate'] = this.defaultFixedRate;
                    break;
                case 25:
                    this.setState({ rate: 3.70 });
                    state['rate'] = 3.70;
                    break;
                case 30:
                    this.setState({ rate: 3.75 });
                    state['rate'] = 3.75;
                    break;
                case 35:
                    this.setState({ rate: 3.75 });
                    state['rate'] = 3.75;
                    break;
            }

        }

        this.calculate(state);
    }

    onSliderChangeProperty(key, value) {
        const state = { ...this.state };
        state[key] = parseFloat(value);

        if (key === 'buyingCostsProperty') {
            const closingCosts = state[key] * (this.state.closingCostsFactorProperty / 100);
            state.closingCostsProperty = closingCosts;
            state.objectCostsProperty = state[key] + closingCosts;
        }

        if (key === 'equityProperty' && state['objectCostsProperty'] < state[key] / 0.8)
            state['objectCostsProperty'] = parseFloat((state[key] / 0.8).toFixed(2));

        this.setState(state);
    }

    onSliderEndProperty() {
        this.calculateProperty(this.state);
    }

    onInputChangeProperty(value, key) {
        const state = { ...this.state };
        state[key] = parseFloat(value);

        if (key === 'buyingCostsProperty') {
            const closingCosts = state[key] * (this.state.closingCostsFactorProperty / 100);
            state.closingCostsProperty = closingCosts;
            state.objectCostsProperty = state[key] + closingCosts;
        }

        if (key === 'equityProperty' && state['objectCostsProperty'] < state[key] / 0.8)
            state['objectCostsProperty'] = parseFloat((state[key] / 0.8).toFixed(2));

        this.setState(state);
        this.calculateProperty(state);
    }

    onModeChangeProperty(e) {
        this.setState({ modeProperty: e.target.value });
    }

    calculate(state) {
        const data = new FormData();
        data.append('objectCosts', state.objectCosts);
        data.append('equity', state.equity);
        data.append('duration', state.duration);
        data.append('rate', state.rate);

        window.fetch('https://kreditaustria.at/wp-json/creditcalc/calculate', {
            method: 'POST',
            referrerPolicy: "no-referrer",
            body: data
        })
            .then(response => response.json())
            .then(json => this.updateResults(json))
            .catch(error => console.log('error: ', error));
    }

    calculateProperty(state) {
        const data = new FormData();
        data.append('objectCosts', state.objectCostsProperty);
        data.append('monthlyInstallment', state.output.monthlyInstallmentProperty);
        data.append('equity', state.equityProperty);
        data.append('duration', state.durationProperty);
        data.append('rate', state.rateProperty);
        data.append('mode', state.modeProperty);

        window.fetch('https://kreditaustria.at/wp-json/creditcalc/calculate', {
            method: 'POST',
            referrerPolicy: "no-referrer",
            body: data
        })
            .then(response => response.json())
            .then(json => this.updateResultsProperty(json))
            .catch(error => console.log('error: ', error));
    }

    updateResults(data) {
        this.setState(prevState => ({
            output: {
                ...prevState.output, // Spread the existing properties of the output object
                creditAmount: data.creditAmount + prevState.equity, // Update specific properties
                effectiveRate: data.effectiveRate,
                monthlyInstallment: data.monthlyInstallment,
                totalRefund: data.totalRefund,
                avail: data.avail,
                monthlyBonus: data.monthlyBonus,
                handlingFee: data.handlingFee,
                deedRegistration: data.deedRegistration,
                monthlyActivityCharge: data.monthlyActivityCharge
            }
        }));

        if (window.hasOwnProperty('jQuery')) {
            window.jQuery('.creditcalc-form-hidden input[name=objectCosts]').val(this.formatCurrencyNumber(this.state.objectCosts));
            window.jQuery('.creditcalc-form-hidden input[name=equity]').val(this.formatCurrencyNumber(this.state.equity));
            window.jQuery('.creditcalc-form-hidden input[name=duration]').val(this.state.duration);
            window.jQuery('.creditcalc-form-hidden input[name=rate]').val(this.state.rate.toFixed(3));
            // window.jQuery('.creditcalc-form-hidden input[name=creditAmount]').val(this.formatCurrencyNumber(data.creditAmount));
            window.jQuery('.creditcalc-form-hidden input[name=creditAmount]').val(this.formatCurrencyNumber(data.creditAmount + this.state.equity));
            window.jQuery('.creditcalc-form-hidden input[name=monthlyInstallment]').val(this.formatCurrencyNumber(data.monthlyInstallment));
        }
    }

    updateResultsProperty(data) {
        this.setState(prevState => ({
            output: {
                ...prevState.output, // Spread the existing properties of the output object
                creditAmountProperty: data.creditAmount, // Update specific properties
                effectiveRateProperty: data.effectiveRate,
                objectCostsProperty: data.objectCosts,
                monthlyInstallmentProperty: data.monthlyInstallment,
                totalRefundProperty: data.totalRefund,
                availProperty: data.avail,
                monthlyBonusProperty: data.monthlyBonus,
                handlingFeeProperty: data.handlingFee,
                deedRegistrationProperty: data.deedRegistration,
                monthlyActivityChargeProperty: data.monthlyActivityCharge
            }
        }));
        

        if (window.hasOwnProperty('jQuery')) {
            window.jQuery('.creditcalc-form-hidden input[name=objectCosts]').val(this.formatCurrencyNumber(this.state.objectCostsProperty));
            window.jQuery('.creditcalc-form-hidden input[name=equity]').val(this.formatCurrencyNumber(this.state.equityProperty));
            window.jQuery('.creditcalc-form-hidden input[name=duration]').val(this.state.durationProperty);
            window.jQuery('.creditcalc-form-hidden input[name=rate]').val(this.state.rateProperty.toFixed(3));
            window.jQuery('.creditcalc-form-hidden input[name=creditAmount]').val(this.formatCurrencyNumber(data.creditAmount));
            window.jQuery('.creditcalc-form-hidden input[name=monthlyInstallment]').val(this.formatCurrencyNumber(data.monthlyInstallment));
        }
    }

    formatCurrencyNumber(input, symbol) {
        let result = currency.format(input);

        if (!isNaN(input) && Math.abs(input.toFixed(3) - input.toFixed(0)) < 0.01)
            result = currency.format(parseInt(input)).replace(',00', ',-');

        return symbol + ' ' + result.replace(/\u00a0EUR/g, '');
    }

    formatPercentNumber(input) {
        if (!isNaN(input) && input.toFixed(3) - input.toFixed(0) === 0)
            return percentage.format(parseInt(input)).replace(',000', '');

        return percentage.format(input);
    }

    handleTabClick(tab) {

        this.setState({ activeTab: tab });

        if (tab === TAB_FIXED) {
            this.setState({ objectCosts: this.defaultFixedObjectCosts });
            this.setState({ equity: this.defaultFixedEquity });
            this.setState({ duration: this.defaultFixedDuration });
            this.setState({ rate: this.defaultFixedRate }, () => {
                this.calculate(this.state);
            });
        }

        if (tab === TAB_VARIABLE) {
            this.setState({ objectCosts: this.defaultVariableObjectCosts });
            this.setState({ equity: this.defaultVariableEquity });
            this.setState({ duration: this.defaultVariableDuration });
            this.setState({ rate: this.defaultVariableRate }, () => {
                this.calculate(this.state);
            });
        }

    }

    handleOuterTabClick(tab) {
        this.setState({ outerActiveTab: tab });
    }

    render() {
        return (
            <div className="tabContainer">
                <div className='tabList'>
                    <div onClick={() => this.handleOuterTabClick(TAB_COMMON)} className={`tabButton common`}>{TAB_COMMON}</div>
                    <div onClick={() => this.handleOuterTabClick(TAB_PROPERTY)} className={`tabButton property`}>{TAB_PROPERTY}</div>
                </div>
                <div className='tabContent'>
                    {this.state.outerActiveTab === TAB_COMMON && (
                        <>
                            <div className='tabContent-image'>
                                <div className='tab_image-container' style={{ backgroundImage: "url('https://www.staging2.kreditaustria.at/wp-content/uploads/2024/03/10-scaled.jpg')" }}>
                                </div>
                                <div className='image-content'>
                                    <h1 className="">Jetzt Kredit berechnen</h1>
                                    <p className="">
                                        * Repräsentatives Beispiel für einen Kreditvertrag mit einem Kreditbetrag von {this.formatCurrencyNumber(this.state.output.creditAmount, '€')} besichert
                                        mit einer Hypothek; Laufzeit {this.state.duration} Jahre,&nbsp;
                                        {
                                            this.state.activeTab === TAB_VARIABLE ?
                                                <>
                                                    Zinssatz {this.formatPercentNumber(this.state.rate)} % p.a. variabel,
                                                    effektiver Zinssatz, {this.formatPercentNumber(this.state.output.effectiveRate)} % p.a.&nbsp;
                                                </>
                                                :
                                                <>
                                                    fixer Zinssatz {this.formatPercentNumber(this.state.rate)} % p.a. (effektiver Zinssatz, {this.formatPercentNumber(this.state.output.effectiveRate)} % p.a.).&nbsp;
                                                </>
                                        }
                                        Einberechnete Kosten (jeweils einmalig vom Kreditbetrag):
                                        Bearbeitungsgebühr {this.state.output.handlingFee} %, Grundbucheintragungsgebühr {this.state.output.deedRegistration} %. Kontoführung
                                        vierteljährig {this.formatCurrencyNumber(this.state.output.monthlyActivityCharge * 3, '€')}. {this.state.duration * 12} monatliche
                                        Raten zu {this.formatCurrencyNumber(this.state.output.monthlyInstallment, '€')} zu zahlender Gesamtbetrag {this.formatCurrencyNumber(this.state.output.totalRefund, '€')}, tatsächlicher
                                        Auszahlungsbetrag {this.formatCurrencyNumber(this.state.output.avail, '€')} (Gesamtkreditbetrag – Kreditnebenkosten bereits abgezogen). Sämtliche Werte in der Berechnung verstehen
                                        sich als unverbindliche Richtwerte und sind von Bonität, Volumen, Laufzeit, Verwendungszweck und Besicherung abhängig. Beispiel für linear
                                        fallende Kreditrestschuldversicherung, Versicherungssumme = Kreditnominale, für einen 35-jährigen Nichtraucher ohne Erschwerniszulagen mit
                                        einer Monatsprämie von {this.formatCurrencyNumber(this.state.output.monthlyBonus, '€')}.
                                    </p>
                                </div>
                            </div>
                            <div className='tabContent-calc common'>
                                <div className="creditCalcContainer">
                                    <div className="creditCalcContainerInner">
                                        <div className='creditCalcTabContainer'>
                                            <button
                                                onClick={() => this.handleTabClick(TAB_VARIABLE)}
                                                className={`creditCalcTabButton ${this.state.activeTab === TAB_VARIABLE ? 'active' : ''}`}
                                            >
                                                {TAB_VARIABLE}
                                            </button>
                                            <button
                                                onClick={() => this.handleTabClick(TAB_FIXED)}
                                                className={`creditCalcTabButton ${this.state.activeTab === TAB_FIXED ? 'active' : ''}`}
                                            >
                                                {TAB_FIXED}
                                            </button>
                                        </div>

                                        <CalcControl
                                            label="Wunschkredit (EUR)"
                                            name="objectCosts"
                                            min={20000}
                                            max={1000000}
                                            step={1000}
                                            currency={true}
                                            value={this.state.objectCosts}
                                            onSliderChange={this.onSliderChange}
                                            onInputChange={this.onInputChange}
                                            onAfterChange={this.onSliderEnd}
                                        />

                                        <CalcControl
                                            label="Eigenmittel (EUR)"
                                            name="equity"
                                            min={0}
                                            max={4000000}
                                            // max={1000000}
                                            step={1000}
                                            currency={true}
                                            value={this.state.equity}
                                            onSliderChange={this.onSliderChange}
                                            onInputChange={this.onInputChange}
                                            onAfterChange={this.onSliderEnd}
                                        />

                                        <CalcControl
                                            label="Laufzeit (Jahre)"
                                            name="duration"
                                            min={5}
                                            max={this.state.activeTab === TAB_FIXED ? 50 : 50}
                                            step={1}
                                            value={this.state.duration}
                                            onSliderChange={this.onSliderChange}
                                            onInputChange={this.onInputChange}
                                            onAfterChange={this.onSliderEnd}
                                        />

                                        <CalcControl
                                            label="Zinssatz (%)"
                                            name="rate"
                                            min={0.375}
                                            max={10}
                                            step={0.125}
                                            decimals={3}
                                            value={this.state.rate}
                                            onSliderChange={this.onSliderChange}
                                            onInputChange={this.onInputChange}
                                            onAfterChange={this.onSliderEnd}
                                        />

                                        <div className="creditCalcCreditAmount">
                                            <label className="creditCalcCreditAmountLabel">Kreditbetrag</label>
                                            <h1>{this.formatCurrencyNumber(this.state.output.creditAmount, 'EUR')} *</h1>
                                        </div>

                                        <div className="creditCalcMonthlyInstallment">
                                            <label className="creditCalcMonthlyInstallmentLabel">Monatsrate ab</label>
                                            <h1>{this.formatCurrencyNumber(this.state.output.monthlyInstallment, 'EUR')}</h1>
                                        </div>

                                        <div className="creditCalcCreditRequestContainer">
                                            <a className="creditCalcCreditRequest" href={`https://kreditaustria.at/anfrage?creditAmount=${this.state.output.creditAmount}&duration=${this.state.duration}&equity=${this.state.equity}&rate=${this.state.rate}`}>zur Kreditanfrage</a>
                                        </div>
                                        <div className='description-text'>
                                            <p className="">
                                                * Repräsentatives Beispiel für einen Kreditvertrag mit einem Kreditbetrag von {this.formatCurrencyNumber(this.state.output.creditAmount, '€')} besichert
                                                mit einer Hypothek; Laufzeit {this.state.duration} Jahre,&nbsp;
                                                {
                                                    this.state.activeTab === TAB_VARIABLE ?
                                                        <>
                                                            Zinssatz {this.formatPercentNumber(this.state.rate)} % p.a. variabel,
                                                            effektiver Zinssatz, {this.formatPercentNumber(this.state.output.effectiveRate)} % p.a.&nbsp;
                                                        </>
                                                        :
                                                        <>
                                                            fixer Zinssatz {this.formatPercentNumber(this.state.rate)} % p.a. (effektiver Zinssatz, {this.formatPercentNumber(this.state.output.effectiveRate)} % p.a.).&nbsp;
                                                        </>
                                                }
                                                Einberechnete Kosten (jeweils einmalig vom Kreditbetrag):
                                                Bearbeitungsgebühr {this.state.output.handlingFee} %, Grundbucheintragungsgebühr {this.state.output.deedRegistration} %. Kontoführung
                                                vierteljährig {this.formatCurrencyNumber(this.state.output.monthlyActivityCharge * 3, '€')}. {this.state.duration * 12} monatliche
                                                Raten zu {this.formatCurrencyNumber(this.state.output.monthlyInstallment, '€')} zu zahlender Gesamtbetrag {this.formatCurrencyNumber(this.state.output.totalRefund, '€')}, tatsächlicher
                                                Auszahlungsbetrag {this.formatCurrencyNumber(this.state.output.avail, '€')} (Gesamtkreditbetrag – Kreditnebenkosten bereits abgezogen). Sämtliche Werte in der Berechnung verstehen
                                                sich als unverbindliche Richtwerte und sind von Bonität, Volumen, Laufzeit, Verwendungszweck und Besicherung abhängig. Beispiel für linear
                                                fallende Kreditrestschuldversicherung, Versicherungssumme = Kreditnominale, für einen 35-jährigen Nichtraucher ohne Erschwerniszulagen mit
                                                einer Monatsprämie von {this.formatCurrencyNumber(this.state.output.monthlyBonus, '€')}.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {this.state.outerActiveTab === TAB_PROPERTY && (
                        <>
                            <div className='tabContent-image'>

                                <div className='tab_image-container' style={{ backgroundImage: "url('https://www.staging2.kreditaustria.at/wp-content/uploads/2024/04/Kredit-Austria-Startseite-2024-04-12-2-scaled.jpg')" }}>
                                </div>
                                <div className='image-content'>
                                    <h1>Jetzt Kredit<br />berechnen</h1>
                                    <p>
                                        * Repräsentatives Beispiel für einen Kreditvertrag mit einem Kreditbetrag von {this.formatCurrencyNumber(this.state.output.creditAmountProperty, '€')} besichert
                                        mit einer Hypothek Laufzeit {this.state.durationProperty} Jahre, Zinssatz {this.formatPercentNumber(this.state.rateProperty)} % p.a. fix,
                                        effektiver Zinssatz, {this.formatPercentNumber(this.state.output.effectiveRateProperty)} % p.a. Einberechnete Kosten (jeweils einmalig vom Kreditbetrag):
                                        Bearbeitungsgebühr {this.state.output.handlingFeeProperty} %, Grundbucheintragungsgebühr {this.state.output.deedRegistrationProperty} %. Kontoführung
                                        vierteljährig {this.formatCurrencyNumber(this.state.output.monthlyActivityChargeProperty * 3, '€')}. {this.state.durationProperty * 12} monatliche
                                        Raten zu {this.formatCurrencyNumber(this.state.output.monthlyInstallmentProperty, '€')} zu zahlender Gesamtbetrag {this.formatCurrencyNumber(this.state.output.totalRefundProperty, '€')}, tatsächlicher
                                        Auszahlungsbetrag {this.formatCurrencyNumber(this.state.output.availProperty, '€')} (Auszahlungsbetrag nach Abzug Kreditnebenkosten). Sämtliche Werte in der Berechnung verstehen sich als unverbindliche Richtwerte und sind von Bonität,
                                        Volumen, Laufzeit, Lebensalter, Verwendungszweck und konkreter Besicherung abhängig. Die tatsächlichen Werte können, je nach kreditwährendem Institut von dieser Musterberechnung abweichen. Effektivverzinsung,
                                        Gesamteinmalkosten und Gesamtbelastung werden nach Vorliegen der konkreten Bonitätsdaten berechnet bzw. alternative Finanzierungsvarianten in einem persönlichen Gespräch vorgestellt. Beispiel für linear
                                        fallende Kreditrestschuldversicherung, Versicherungssumme = Kreditnominale, für einen 35 jährigen Nichtraucher ohne Erschwerniszulagen mit
                                        einer Monatsprämie von {this.formatCurrencyNumber(this.state.output.monthlyBonusProperty, '€')}.
                                    </p>
                                </div>
                            </div>
                            <div className='tabContent-calc property'>
                                <div className="creditCalcContainer">
                                    <form ref={this.formRef} className="creditCalcContainerInner" action={`https://kreditaustria.at/${this.state.targetProperty}`} method="post" target="_blank">
                                        <PropertyCalcControl
                                            label="Kaufpreis (EUR)"
                                            name="buyingCostsProperty"
                                            min={0}
                                            max={10000000}
                                            step={1000}
                                            currency={true}
                                            decimals={0}
                                            value={this.state.buyingCostsProperty}
                                            onSliderChange={this.onSliderChangeProperty}
                                            onInputChange={this.onInputChangeProperty}
                                            onAfterChange={this.onSliderEndProperty}
                                            tabIndex={1}
                                            preventEnter
                                        />

                                        <PropertyCalcControl
                                            label="Kaufnebenkosten ca. 6,5% vom Kaufpreis (EUR)"
                                            subLabel="(Grunderwerbssteuer, Eintragungsgebühr, Vertragsgebühr)"
                                            name="closingCostsProperty"
                                            currency={true}
                                            value={this.state.closingCostsProperty}
                                            readOnly
                                            tabIndex={-1}
                                            preventEnter
                                        />

                                        <hr />

                                        <PropertyCalcControl
                                            className="credit-calc-gap"
                                            label="Gesamtkaufpreis (EUR)"
                                            name="objectCostsProperty"
                                            currency={true}
                                            value={this.state.objectCostsProperty}
                                            readOnly
                                            tabIndex={-1}
                                            preventEnter
                                        />

                                        <PropertyCalcControl
                                            label="abzüglich Eigenmittel (EUR)"
                                            subLabel="20% vom Gesamtkaufpreis im Regelfall notwendig"
                                            name="equityProperty"
                                            min={0}
                                            max={10000000}
                                            step={1000}
                                            currency={true}
                                            decimals={0}
                                            value={this.state.equityProperty}
                                            onSliderChange={this.onSliderChangeProperty}
                                            onInputChange={this.onInputChangeProperty}
                                            onAfterChange={this.onSliderEndProperty}
                                            tabIndex={2}
                                            preventEnter
                                        />

                                        <hr />

                                        <div class="flexContainer">
                                            <div class="flexItem">
                                                <PropertyCalcControl
                                                    className="credit-calc-gap"
                                                    label="benötigter Kreditbetrag (EUR)"
                                                    name="creditAmountProperty"
                                                    currency={true}
                                                    value={this.state.output.creditAmountProperty}
                                                    readOnly
                                                    tabIndex={-1}
                                                    preventEnter
                                                />
                                            </div>
                                            <div class="flexItem">
                                                <PropertyCalcControl
                                                    label="Laufzeit (Jahre)"
                                                    subLabel="Annahme *"
                                                    name="durationProperty"
                                                    value={this.state.durationProperty}
                                                    readOnly
                                                    tabIndex={-1}
                                                    preventEnter
                                                />
                                            </div>
                                        </div>

                                        <div class="flexContainer">
                                            <div class="flexItem">
                                                <PropertyCalcControl
                                                    label="Zinssatz (%)"
                                                    subLabel="Annahme *"
                                                    name="rateProperty"
                                                    decimals={3}
                                                    value={this.state.rateProperty}
                                                    readOnly
                                                    tabIndex={-1}
                                                    preventEnter
                                                />
                                            </div>
                                            <div class="flexItem">
                                                <div className="creditCalcMonthlyInstallmentProperty">
                                                    <label className="creditCalcMonthlyInstallmentLabel">Monatsrate ab</label>
                                                    <h1>{this.formatCurrencyNumber(this.state.output.monthlyInstallmentProperty, 'EUR')}</h1>
                                                </div>
                                            </div>
                                        </div>

                                        <input type="hidden" name="referrer" value={this.state.referrerProperty} readOnly />
                                        <input type="hidden" name="objectType" value={this.state.objectTypeProperty} readOnly />
                                        <input type="hidden" name="creditAmount" value={parseFloat(this.state.output.creditAmountProperty.toFixed(2))} readOnly />
                                        <input type="hidden" name="monthlyInstallment" value={parseFloat(this.state.output.monthlyInstallmentProperty.toFixed(2))} readOnly />
                                        <input type="hidden" name="effectiveRate" value={parseFloat(this.state.output.effectiveRateProperty.toFixed(3))} readOnly />
                                        <input type="hidden" name="totalRefund" value={parseFloat(this.state.output.totalRefundProperty.toFixed(2))} readOnly />
                                        <input type="hidden" name="avail" value={parseFloat(this.state.output.availProperty.toFixed(2))} readOnly />
                                        <input type="hidden" name="monthlyBonus" value={parseFloat(this.state.output.monthlyBonusProperty.toFixed(2))} readOnly />
                                        <input type="hidden" name="handlingFee" value={parseFloat(this.state.output.handlingFeeProperty.toFixed(2))} readOnly />
                                        <input type="hidden" name="deedRegistration" value={parseFloat(this.state.output.deedRegistrationProperty.toFixed(2))} readOnly />
                                        <input type="hidden" name="monthlyActivityCharge" value={parseFloat(this.state.output.monthlyActivityChargeProperty.toFixed(2))} readOnly />

                                        <div className="creditCalcCreditRequestContainer">
                                            <button className="creditCalcCreditRequest anchor-like-button" onClick={this.onSubmit} tabIndex={3}>zur Kreditanfrage</button>
                                        </div>
                                        <div className="description-text">
                                            <p>
                                                * Repräsentatives Beispiel für einen Kreditvertrag mit einem Kreditbetrag von {this.formatCurrencyNumber(this.state.output.creditAmountProperty, '€')} besichert
                                                mit einer Hypothek Laufzeit {this.state.durationProperty} Jahre, Zinssatz {this.formatPercentNumber(this.state.rateProperty)} % p.a. fix,
                                                effektiver Zinssatz, {this.formatPercentNumber(this.state.output.effectiveRateProperty)} % p.a. Einberechnete Kosten (jeweils einmalig vom Kreditbetrag):
                                                Bearbeitungsgebühr {this.state.output.handlingFeeProperty} %, Grundbucheintragungsgebühr {this.state.output.deedRegistrationProperty} %. Kontoführung
                                                vierteljährig {this.formatCurrencyNumber(this.state.output.monthlyActivityChargeProperty * 3, '€')}. {this.state.durationProperty * 12} monatliche
                                                Raten zu {this.formatCurrencyNumber(this.state.output.monthlyInstallmentProperty, '€')} zu zahlender Gesamtbetrag {this.formatCurrencyNumber(this.state.output.totalRefundProperty, '€')}, tatsächlicher
                                                Auszahlungsbetrag {this.formatCurrencyNumber(this.state.output.availProperty, '€')} (Auszahlungsbetrag nach Abzug Kreditnebenkosten). Sämtliche Werte in der Berechnung verstehen sich als unverbindliche Richtwerte und sind von Bonität,
                                                Volumen, Laufzeit, Lebensalter, Verwendungszweck und konkreter Besicherung abhängig. Die tatsächlichen Werte können, je nach kreditwährendem Institut von dieser Musterberechnung abweichen. Effektivverzinsung,
                                                Gesamteinmalkosten und Gesamtbelastung werden nach Vorliegen der konkreten Bonitätsdaten berechnet bzw. alternative Finanzierungsvarianten in einem persönlichen Gespräch vorgestellt. Beispiel für linear
                                                fallende Kreditrestschuldversicherung, Versicherungssumme = Kreditnominale, für einen 35 jährigen Nichtraucher ohne Erschwerniszulagen mit
                                                einer Monatsprämie von {this.formatCurrencyNumber(this.state.output.monthlyBonusProperty, '€')}.
                                            </p>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default App;
